<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import ExcelExport from "@/components/ExcelExport.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Staff Payroll",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
    ExcelExport,
  },
  data() {
    return {
      title: "Staff Payroll",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Staff Payroll",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "staff",
          sortable: true,
          label: "STAFF",
        },
        {
          key: "gross_pay",
          sortable: true,
          label: "GROSS PAY",
        },

        {
          key: "payee",
          sortable: true,
          label: "PAYEE",
        },
        {
          key: "nssf",
          sortable: true,
          label: "NSSF",
        },
        {
          key: "net_pay",
          sortable: true,
          label: "NET PAY",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingPayroll: [],
      staffError: "",
      grosspayError: "",
      payeeError: "",
      nssfError: "",

      // Value from user input for adding unit
      data: {
        staff: "",
        gross_pay: "",
        payee: "0",
        nssf: "0",
      },
      // edit unit
      editdata: {
        payee: "",
        gross_pay: "",
        nssf: "",
        id: "",
      },
      // delete unit
      deletedata: {
        staff: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("staff", ["StaffSave", "Staff", "StaffPayroll"]),
    ...mapGetters("auth", ["MyUserPerm", "branchid"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.StaffPayroll ? this.StaffPayroll.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StaffPayroll ? this.StaffPayroll.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          this.resetAdd();
          this.resetEdit();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStaff: "staff/fetchAllStaff",
      AddStaffPayroll: "staff/addStaffPayroll",
      FetchStaffPayroll: "staff/fetchStaffPayroll",
      EditStaffPayroll: "staff/editStaffPayroll",
      DeleteStaffPayroll: "staff/deleteStaffPayroll",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addStaffPayroll(modalId) {
      this.modal_id = modalId;

      if (this.data.staff === "") {
        this.staffError = "Staff field is required";
      } else if (this.data.gross_pay === "") {
        this.grosspayError = "Gross Pay field is required";
        return;
      }
      this.validateStaff();
      if (this.staffError != "") {
        return;
      }
      this.AddStaffPayroll(this.data);
    },

    validateStaff() {
      if (this.data.staff != "") {
        let selStaffPayroll = this.StaffPayroll.filter((item) => {
          return item.staff_id == this.data.staff;
        });
        let staffCount = selStaffPayroll.length;
        if (staffCount > 0) {
          this.staffError = "StaffPayroll with these details  already Exists";
        }
      }
    },

    resetAdd() {
      this.data.staff = "";
      this.data.gross_pay = "";
      this.data.payee = "0";
      this.data.nssf = "0";
      this.modal_id = "";
    },
    resetEdit() {
      this.editdata.staff = "";
      this.editdata.gross_pay = "";
      this.editdata.payee = "";
      this.editdata.nssf = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.staff = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.staffError = "";
      this.grosspayError = "";
      this.payeeError = "";
      this.nssfError = "";
    },

    showEditModal(val) {
      this.editdata.staff = val.item.staff;
      this.editdata.gross_pay = val.item.gross_pay;
      this.editdata.payee = val.item.payee == 0 ? 0 : 1;
      this.editdata.nssf = val.item.nssf == 0 ? 0 : 1;
      this.editdata.id = val.item.id;
    },

    editStaffPayroll(modalId) {
      this.modal_id = modalId;
      this.resetError();

      if (this.editdata.gross_pay === "") {
        this.grosspayError = "Gross Pay field is required";
        return;
      }

      this.EditStaffPayroll(this.editdata);
    },

    validateStaffEdit() {
      let selStaffPayroll = this.StaffPayroll.filter((item) => {
        return (
          item.staff_id == parseInt(this.editdata.staff) &&
          item.id != this.editdata.id
        );
      });
      let staffCount = selStaffPayroll.length;
      if (staffCount > 0) {
        this.staffError = "StaffPayroll with these details  already Exists";
      }
    },

    showDeleteModal(val) {
      this.deletedata.staff = val.item.staff;
      this.deletedata.id = val.item.id;
    },

    deleteStaffPayroll(modalId) {
      this.modal_id = modalId;
      this.DeleteStaffPayroll(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas() {
      this.data.gross_pay = this.thousandSeprator(this.data.gross_pay);
      this.editdata.gross_pay = this.thousandSeprator(this.editdata.gross_pay);
    },

    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting staff payroll. Please try again.",
        confirmButtonText: "OK",
      });
    },

    parseAmount(value) {
      if (value === null || value === undefined || value === "") {
        return 0;
      }
      const numeric = Number(value.toString().replace(/,/g, "").trim());
      return Number.isNaN(numeric) ? 0 : numeric;
    },

    calculateNetPay(payrollItem) {
      const grossPay = this.parseAmount(payrollItem.gross_pay);
      const nssf = this.parseAmount(payrollItem.nssf);
      const payee = this.parseAmount(payrollItem.payee);
      const deductions = nssf + payee;
      return Math.max(grossPay - deductions, 0);
    },
  },
  created() {
    this.FetchStaff();
    this.FetchStaffPayroll();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-4">
                <h4 class="card-title">Staff Payroll</h4>
              </div>
              <div class="col-12 col-md-4 text-md-end text-start mb-2 mb-md-0">
                <ExcelExport
                  endpoint="staff_payroll/export"
                  filename="staff_payroll_report.xlsx"
                  :payload="{}"
                  button-text="Export Excel"
                  button-variant="info"
                  icon-class="fas fa-download"
                  @export-error="handleExportError"
                />
              </div>
              <div
                v-if="MyUserPerm.add_staff_payroll == 1 && branchid != 0"
                class="col-12 col-md-4 text-md-end text-start"
              >
                <b-button v-b-modal.add_staffpayroll-modal variant="primary"
                  >Enroll Staff</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="StaffPayroll ? StaffPayroll : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(net_pay)="data">
                  {{ thousandSeprator(calculateNetPay(data.item).toString()) }}
                </template>

                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      v-if="MyUserPerm.edit_staff_payroll == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-payroll-modal
                      @click="showEditModal(data)"
                      ><i class="fa fa-edit"></i
                    ></b-button>
                    <b-button
                      size="sm"
                      v-if="MyUserPerm.delete_staff_payroll == 1"
                      variant="danger"
                      v-b-modal.delete-payroll-modal
                      @click="showDeleteModal(data)"
                      ><i class="fa fa-trash"></i
                    ></b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <Loader v-if="!StaffPayroll" />
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal
      id="add_staffpayroll-modal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <template #modal-title> Add Staff Payroll</template>

      <div class="row">
        <div class="form-group mb-3">
          <label>Staff</label>
          <div class="input-group">
            <model-list-select
              :list="Staff ? Staff : []"
              v-model="data.staff"
              option-value="id"
              option-text="name"
              placeholder="Select staff"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="staffError">
            <em>{{ staffError }}</em>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Gross Pay</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Gross Pay "
              class="form-control"
              v-model="data.gross_pay"
              @input="addCommas()"
            />
          </div>
          <div class="text-danger" v-if="grosspayError">
            <em>{{ grosspayError }}</em>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Payee</label>
          <div class="input-group">
            <select type="text" class="form-control" v-model="data.payee">
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Nssf</label>
          <div class="input-group">
            <select type="text" class="form-control" v-model="data.nssf">
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add_staffpayroll-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addStaffPayroll('add_staffpayroll-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            v-if="StaffSave"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--     edit modal starts-->
    <b-modal id="edit-payroll-modal" hide-footer>
      <template #modal-title> Edit Staff {{ editdata.name }}</template>
      <div class="row">
        <div class="form-group mb-3 col-6">
          <label>Gross Pay</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Gross Pay "
              class="form-control"
              v-model="editdata.gross_pay"
              @input="addCommas()"
            />
          </div>
          <div class="text-danger" v-if="grosspayError">
            <em>{{ grosspayError }}</em>
          </div>
        </div>

        <div class="form-group mb-3 col-6">
          <label>Payee</label>
          <div class="input-group">
            <select type="text" class="form-control" v-model="editdata.payee">
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
        </div>

        <div class="form-group mb-3 col-6">
          <label>Nssf</label>
          <div class="input-group">
            <select type="text" class="form-control" v-model="editdata.nssf">
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-payroll-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editStaffPayroll('edit-payroll-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="StaffSave"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-payroll-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title>
        Delete Payroll for Staff {{ deletedata.name }}</template
      >
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-payroll-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteStaffPayroll('delete-payroll-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="StaffSave"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
</style>
